import React from 'react'

export default function Title({title}) {
    return (
        <div>
            <h1>{title}</h1>
        </div>
    )
}
